module.exports = __webpack_public_path__ + "static/scale-model-of-bent-f-stoppery-in-albuquerque-new-mexico-5d2791afc8cf61cd6ca45d7e9c1b60e0.png";